var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c("DateSelect", { ref: "dateFrom" }),
            _vm._v(" "),
            _c("DateSelect", { ref: "dateTo" }),
            _vm._v(" "),
            _c("LoadingButton", {
              attrs: {
                title: "Показать",
                type: "button",
                loading: _vm.loading,
                color: _vm.$constants.PRIMARY_COLOR,
                onClick: () => _vm.showReport(),
                className: "btn ml-1 btn-outline-info",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    !_vm.loading && _vm.ordersReport
      ? _c(
          "div",
          { staticClass: "flex" },
          [
            _c("Funnel", {
              attrs: { type: "post", data: _vm.ordersReport.post },
            }),
            _vm._v(" "),
            _c("Funnel", {
              attrs: { type: "delivery", data: _vm.ordersReport.delivery },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }